import React from 'react';

const IntegrationDocumentBadge = ({
  integrationSourceLabel,
  integrationExternalReference,
  compact = false,
}) => {
  if (!integrationSourceLabel && !integrationExternalReference) {
    return null;
  }

  const tooltip = [
    integrationSourceLabel ? `Integrado desde ${integrationSourceLabel}` : 'Integrado desde ERP',
    integrationExternalReference ? `Ref: ${integrationExternalReference}` : null,
    'Solo lectura en Contify',
  ]
    .filter(Boolean)
    .join('. ');

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-violet-100 text-violet-800 ${
        compact ? '' : 'mt-1'
      }`}
      title={tooltip}
    >
      {compact ? 'ERP' : 'Integrado ERP'}
    </span>
  );
};

export default IntegrationDocumentBadge;
